export class ValueCalculator {
  constructor(initValue) {
    this.measuredValue = initValue;
  }

  calculate(/*newValue*/) {
    return this.measuredValue;
  }

  reset(initvalue) {
    this.measuredValue = initvalue;
  }
}
